import {
  SET_DEPARTURE,
  SET_TOURID,
  SET_PROMO_CODE,
  SET_CITYID,
  SET_PASSENGER_TYPE,
  SET_PROCESSING,
  SET_BOOKING,
  SET_PRICES,
  SET_PASSENGER_DETAILS,
  SET_LOCKOUT,
  SET_TRIPS_PASSENGERS,
  ADD_TRIPS,
  SET_TOUR_NAME_OVERRIDE
} from './types';
import _filter from 'lodash/filter';


export function SetTourID(tourID){
  return dispatch => dispatch({type:SET_TOURID, payload:{tourID}});
}

export function SetDeparture(date){
  return dispatch => dispatch({type:SET_DEPARTURE, payload:{date}});
}

export function SetPromoCode(promoCode){
  return dispatch => dispatch({type:SET_PROMO_CODE, payload:{promoCode}});
}

export function SetCityID(cityID){
  return dispatch => dispatch({type:SET_CITYID, payload:{cityID}});
}

export function SetPassenger(value){

  let paxArray = [];
  let paxValue = value.Adult;

  for(let i = 0; i < paxValue; i++){
    paxArray.push({"age_category":"Adult"});
  }

  return dispatch => dispatch({type:SET_PASSENGER_TYPE, payload:{paxArray}})
}

export function SetProcessing(value){
  return dispatch => dispatch({type:SET_PROCESSING, payload:value})
}

export function SetBooking(value){
  return dispatch => dispatch({type:SET_BOOKING, payload:value})
}

export function SetPrices(prices){
  return dispatch => dispatch({type:SET_PRICES, payload:{prices}});
}

export function SetPassengerDetails(paxDetails){
  return dispatch => dispatch({type:SET_PASSENGER_DETAILS, payload:paxDetails})
}

export function SetLockout(value){
  return dispatch => dispatch({type:SET_LOCKOUT, payload:value})
}

export function AddTrips(value){
  return dispatch => dispatch({type:ADD_TRIPS, payload:value})
}

export function SetTourNameOveride(value){
  return dispatch => dispatch({type:SET_TOUR_NAME_OVERRIDE, payload:value})
}

/**
 * Set Trips reservation arrray in passenger
 *
 * @param {array} paxArr - Number of passengers
 * @param {array} payload - Sequence payload
 * @param {string} selectedDate - Selected date
 * @param {price} price - price
 * @param {boolean} isEdit - Use for 'Edit Trip' in hoho builder
 */
export function SetTripPassengers(paxArr, payload, selectedDate, price){


   //Check for Trips
   let tripsArray = [];
   const tripsOnly = _filter(payload, ['type', 'product']);

   if(tripsOnly.length > 0){
      for(var tt = 0; tt < tripsOnly.length; tt++){
        tripsArray.push({
          "tour_id": tripsOnly[tt].tour_id,
          "city_id": "0",
          "departure_date": tripsOnly[tt].departure,
          "promo_code": "",
          "passengers": [],
          "add_ons": []
        })
      }
   }



   //Filter non-product trips
   const sectorsOnly = _filter(payload, ['type', 'sector']);


   //Building passenger reservation payload (basket stage)
    let passengersArray = [];
    let reservationArray = [];
    let counter = 0;
    let sequenceLength = sectorsOnly.length - 1;
    let totalPrice = sequenceLength * price;


    for(let i = 0; i < sequenceLength; i++){
      counter++;

      reservationArray.push({
        "date_for": sectorsOnly[i].departure,
        "start_city_id": sectorsOnly[i].transfer[0].stop_id,
        "end_city_id": sectorsOnly[i].transfer[1].stop_id,
        "price":price
      });

      if(counter === sequenceLength){

        for(let j = 0; j < paxArr.length; j++){
          passengersArray.push({
            "index": j,
            "price": totalPrice,
            "reservations":reservationArray
          })
        }
      }
    }


    return dispatch => {
      dispatch({type:SET_TRIPS_PASSENGERS, payload:passengersArray})
      if(tripsArray.length > 0 ) dispatch({type:ADD_TRIPS, payload:tripsArray});
    }
}



// WEBPACK FOOTER //
// ./src/actions/currentBooking.js